import React from 'react';
import { Link } from 'react-router-dom';
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Box,
    Typography,
} from '@mui/material';
import {
    Dashboard,
    Analytics,
    People,
    Inventory,
    Settings,
    Help,
    TrendingUp,
    ShoppingCart,
    Rtt,
    Business
} from '@mui/icons-material';

interface SidebarProps {
    open: boolean;
    onClose: () => void;
    menuActive: string;
}

const menuItems = [
    { text: 'Dashboard', icon: <Dashboard />, active: true, to: '/' },
    // { text: 'Analytics', icon: <Analytics />, to: '/' },
    // { text: 'Sales', icon: <TrendingUp />, to: '/' },
    { text: 'Escritorios', icon: <Business />, to: '/escritorios' },
    { text: 'Documentos', icon: <Inventory />, to: '/documentos' },
    { text: 'Textos', icon: <Rtt />, to: '/paragrafos' },
    // { text: 'Orders', icon: <ShoppingCart />, to: '/' },
    // { text: 'Customers', icon: <People />, to: '/' },
];

const secondaryItems = [
    { text: 'Configurações', icon: <Settings /> },
    // { text: 'Help', icon: <Help /> },
];

const drawerWidth = 240;

const Sidebar: React.FC<SidebarProps> = ({ open, onClose, menuActive }) => {
    return (
        <Drawer
            variant="persistent"
            open={open}
            onClose={onClose}
            ModalProps={{
                keepMounted: true,
            }}
            sx={{
                '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    width: drawerWidth,
                    backgroundColor: '#fafafa',
                },
            }}
        >
            <Box sx={{ overflow: 'auto' }}>
                <Box sx={{ p: 2, pt: 10 }}>
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                        Menu
                    </Typography>
                </Box>

                <List>
                    {menuItems.map((item) => (
                        <Link to={item.to} key={item.text}>
                            <ListItem disablePadding sx={{ px: 1 }}>
                                <ListItemButton
                                    sx={{
                                        borderRadius: 1,
                                        mb: 0.5,
                                        backgroundColor: menuActive === item.text ? 'primary.main' : 'transparent',
                                        color: menuActive === item.text ? 'white' : 'inherit',
                                        '&:hover': {
                                            backgroundColor: menuActive === item.text ? 'primary.dark' : 'action.hover',
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={{ color: menuActive === item.text ? 'white' : 'inherit' }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItemButton>
                            </ListItem>
                        </Link>
                    ))}
                </List>

                <Divider sx={{ mx: 2, my: 2 }} />

                <List>
                    {secondaryItems.map((item) => (
                        <ListItem key={item.text} disablePadding sx={{ px: 1 }}>
                            <ListItemButton sx={{ borderRadius: 1, mb: 0.5 }}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
};

export default Sidebar;